import * as Yup from "yup";

export const GeneralSettingsSchema = Yup.object().shape({
    name: Yup.string().required("Пожалуйста, укажите название"),
    key: Yup.string().required("Пожалуйста, укажите ключ переменной"),
    value: Yup.mixed().required("Пожалуйста, укажите значение"),
});
